import { useUBL, useUBLContext } from '@common/log-manager';

export function useRatingUBL() {
  const sendUbl = useUBL();
  const ublContext = useUBLContext();

  const viewReviewTab = (product_id: string) => {
    sendUbl({
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      navigation_sub: { product_id },
      category: 'click',
      object_section: 'review_top',
      object_id: 'review_all',
      object_type: 'button',
      data: { catalog_product_id: product_id },
    });
  };
  return {
    viewReviewTab,
  };
}
